'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

import {
  useDeepLinkCustomerType,
  useDeepLinkFulfillmentMethod,
  useDeepLinkStore,
  useUpdateQueryParams,
} from '@/hooks';
import { CollectionQueryParams, EnumCustomerType } from '@/types';

const DeepLinkStore = () => {
  const { deepLinkStore } = useDeepLinkStore();
  const { deepLinkCustomerType } = useDeepLinkCustomerType();
  const { deepLinkFulfillmentMethod } = useDeepLinkFulfillmentMethod();
  const { updateQueryParams } = useUpdateQueryParams();

  const searchParams = useSearchParams();
  const storeName = searchParams.get('store');
  const customerType = searchParams
    .get('customerType')
    ?.toUpperCase() as EnumCustomerType;
  const fulfillment = searchParams.get('fulfillment');

  useEffect(() => {
    const hasDeepLinkParams = Boolean(storeName || customerType || fulfillment);

    if (!hasDeepLinkParams) return;

    deepLinkStore(storeName ?? undefined);
    deepLinkCustomerType(customerType);
    deepLinkFulfillmentMethod(fulfillment ?? undefined);

    const cleanedParams = new URLSearchParams(searchParams.toString());
    cleanedParams.delete('store');
    cleanedParams.delete('customerType');
    cleanedParams.delete('fulfillment');

    updateQueryParams(
      Object.fromEntries(cleanedParams.entries()) as CollectionQueryParams,
    );
  }, [storeName, customerType, fulfillment, searchParams]);

  return null;
};

export { DeepLinkStore };
